import React, {useState} from 'react'
import {api} from './api'
import Install from './Install'
import {getTheme, toggleTheme} from './theme'
import {SunIcon, MoonIcon} from './Icons'

export default function Settings({user, onUser, onLogout}) {
  const [name, setName] = useState(user.name || '')
  const [goal, setGoal] = useState({
    calories: String(user.goal.calories || ''),
    maintenance: user.goal.maintenance ? String(user.goal.maintenance) : '',
    protein: user.goal.protein ? String(user.goal.protein) : '',
    carbs: user.goal.carbs ? String(user.goal.carbs) : '',
    fat: user.goal.fat ? String(user.goal.fat) : '',
  })
  const [saved, setSaved] = useState(false)
  const [err, setErr] = useState('')
  const [theme, setThemeState] = useState(getTheme())

  const setG = (k, v) => setGoal(g => ({...g, [k]: v}))
  const flipTheme = () => setThemeState(toggleTheme())

  const save = async () => {
    try {
      const updated = await api.saveProfile(name.trim(), {
        calories: Number(goal.calories) || 0,
        maintenance: Number(goal.maintenance) || 0,
        protein: Number(goal.protein) || 0,
        carbs: Number(goal.carbs) || 0,
        fat: Number(goal.fat) || 0,
      })
      onUser && onUser(updated)
      setSaved(true)
      setTimeout(() => setSaved(false), 1500)
    } catch (e) {
      setErr(e.message)
    }
  }

  const logout = async () => {
    try {
      await api.logout()
    } catch (e) {}
    onLogout && onLogout()
  }

  return (
    <div className="page">
      <header className="page-head">
        <h1>Settings</h1>
        <span className="page-sub">signed in as @{user.username}</span>
      </header>

      <div className="card set-row">
        <span className="field-label">Appearance</span>
        <button className="theme-toggle" onClick={flipTheme} aria-label="toggle light / dark">
          {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
          <span className="theme-toggle-txt">{theme === 'dark' ? 'Dark' : 'Light'}</span>
        </button>
      </div>

      <div className="card">
        <label className="field field-wide">
          <span className="field-label">Display name</span>
          <input className="input" value={name} onChange={e => setName(e.target.value)} placeholder="optional" />
        </label>

        <div className="row">
          <Field
            label="Maintenance (kcal)"
            value={goal.maintenance}
            set={v => setG('maintenance', v)}
            placeholder="2500"
          />
          <Field
            label="Daily target (kcal)"
            value={goal.calories}
            set={v => setG('calories', v)}
            placeholder="2000"
          />
        </div>
        <div className="field-hint">Target is your deficit goal; maintenance is what you burn.</div>

        <div className="field-label" style={{marginTop: 12}}>
          Macro goals (grams, optional)
        </div>
        <div className="row">
          <Field label="Protein" accent="var(--protein)" value={goal.protein} set={v => setG('protein', v)} placeholder="200" />
          <Field label="Carbs" accent="var(--carbs)" value={goal.carbs} set={v => setG('carbs', v)} placeholder="—" />
          <Field label="Fat" accent="var(--fat)" value={goal.fat} set={v => setG('fat', v)} placeholder="—" />
        </div>

        <button className="btn btn-primary btn-block" onClick={save}>
          {saved ? 'Saved ✓' : 'Save'}
        </button>
      </div>

      <Install />

      <button className="btn btn-ghost btn-block" onClick={logout} style={{marginTop: 14}}>
        Log out
      </button>

      <div className="footnote">
        yoked v{process.env.APP_VERSION} · build {process.env.APP_BUILD}
      </div>

      {err && (
        <div className="toast" onClick={() => setErr('')}>
          {err}
        </div>
      )}
    </div>
  )
}

function Field({label, value, set, accent, placeholder}) {
  return (
    <label className="field">
      <span className="field-label" style={accent ? {color: accent} : null}>
        {label}
      </span>
      <input
        className="input"
        type="number"
        inputMode="numeric"
        min="0"
        value={value}
        onChange={e => set(e.target.value)}
        placeholder={placeholder || '0'}
      />
    </label>
  )
}
